import { useCallback, useState } from "react";
import { useNavigationType } from "react-router-dom";

// Lote 131 (Robson, 27/10/2026): "Voltar" deve voltar para onde eu estava (aba anterior). Abas e filtros que
// eram só estado da tela somem quando a pessoa abre um item e volta; aqui ficam guardados na sessão do
// navegador (sessionStorage — morrem ao fechar a aba) e voltam sozinhos SÓ quando a pessoa volta (botão Voltar,
// seta do navegador/celular); abrir a tela pelo menu começa do padrão. `forcado` (ex.: veio de um link com
// ?filtro=) tem prioridade sobre o guardado. Sem sessionStorage (aba anônima etc.) funciona como useState.
export default function useEstadoSessao(chave, inicial, { validos = null, forcado = undefined } = {}) {
  const k = `iapauta_tela_${chave}`;
  const voltando = useNavigationType() === "POP";
  const [valor, setValor] = useState(() => {
    if (forcado !== undefined) return forcado;
    if (!voltando) return typeof inicial === "function" ? inicial() : inicial;
    try {
      const bruto = sessionStorage.getItem(k);
      if (bruto != null) {
        const v = JSON.parse(bruto);
        if (!validos || validos.includes(v)) return v;
      }
    } catch { /* sem armazenamento */ }
    return typeof inicial === "function" ? inicial() : inicial;
  });
  const set = useCallback((x) => {
    setValor((prev) => {
      const n = typeof x === "function" ? x(prev) : x;
      try { sessionStorage.setItem(k, JSON.stringify(n)); } catch { /* sem armazenamento */ }
      return n;
    });
  }, [k]);
  return [valor, set];
}
